import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

export const $Col = styled(Col)`
  [class*='RadioCardContainer'] {
    border-radius: ${({ theme }) => theme.tw.radius.lg};
  }
`;
